import { type FC } from 'preact/compat';
import { useMemo } from 'preact/hooks';

import clsx from 'clsx';

import { useIntl } from '@/app/lib/localization/hooks/use-intl';

import { GameOrientation } from '@/shared/api/game/types';
import { isDesktop } from '@/shared/helpers/is-desktop';
import { useAppState } from '@/shared/stores/app-store/app-store';

import srcImageRotate from '@/assets/images/img-rotate.webp';

import s from './index.module.scss';

interface Props {
  gameOrientation: GameOrientation | undefined;
}

export const OrientationLocker: FC<Props> = ({ gameOrientation }) => {
  const { screenOrientation } = useAppState();

  const shouldShowOrientationLock = useMemo(() => {
    if (
      !gameOrientation ||
      gameOrientation === GameOrientation.BOTH ||
      gameOrientation === screenOrientation ||
      isDesktop()
    ) {
      return false;
    }

    return true;
  }, [gameOrientation, screenOrientation]);

  const translate = useIntl();

  const resolvedKey =
    gameOrientation === GameOrientation.PORTRAIT
      ? 'This game is in vertical mode'
      : 'This game is in horizontal mode';

  if (!shouldShowOrientationLock || !gameOrientation) {
    return null;
  }

  return (
    <div className={clsx(s.locker, s[gameOrientation.toLocaleLowerCase()])}>
      <div className={s.content}>
        <img className={s.img} src={srcImageRotate} alt="rotate-preview" />
        <div className={s.title}>{translate('Rotate your device')}</div>
        <div className={s.subtitle}>{translate(resolvedKey)}</div>
      </div>
    </div>
  );
};
